/**
 * GalleryMobileSheet - Gallery sidebar as bottom Sheet on mobile.
 */

import { useTranslation } from 'react-i18next';
import { Sheet, SheetContent, SheetTitle } from '@/components/v2/ui/Sheet';
import { GalleryV2Sidebar } from './GalleryV2Sidebar';
import type { GalleryImage } from '@/lib/api/gallery-v2';

interface GalleryMobileSheetProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  activeImage: GalleryImage | null;
  onOpenLightbox: () => void;
}

export function GalleryMobileSheet({
  open,
  onOpenChange,
  activeImage,
  onOpenLightbox,
}: GalleryMobileSheetProps) {
  const { t } = useTranslation();

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent
        side="bottom"
        showCloseButton
        className="p-0 h-[70vh] rounded-t-xl overflow-y-auto bg-white dark:bg-neutral-900"
      >
        <SheetTitle className="sr-only">{t('gallery.sidebar.filters')}</SheetTitle>
        <GalleryV2Sidebar
          onClose={() => onOpenChange(false)}
          activeImage={activeImage}
          onOpenLightbox={onOpenLightbox}
        />
      </SheetContent>
    </Sheet>
  );
}
